import React, { useState,useEffect } from 'react';
import { Grid, Button } from '@material-ui/core';
import { LabelValueCard } from '../../../shared_elements';
import NumericLabel from 'react-pretty-numbers';
import { getCurrencyFormat, permissionCheckFn } from '../../../utils';
import { prettyNumberParamsDB } from '../../../constants';
import { checkApiStatus } from '../../../utils';
import EditClaimPayout from './EditClaimPayout';
import { trackActivity } from '../../../utils/mixpanel';
import VerifyAmountModal from './VerifyAmountModal';
import { globalGetService } from '../../../utils/globalApiServices';
import moment from 'moment';

export default function ClaimPayoutCard({item,event, changeClaimStatus, getResponseBack,handleTabChange}){
  const [verifyAmountData,setVerifyAmountData] = useState({modal:false,moduleList:[]})
  const [moduleConstantList,setModuleConstantList] = useState([])
  const getEngineModuleConstant = () => {
    globalGetService(`console/get-constants/?constant_type=psrv_claim_module`)
      .then(response => {
        if (checkApiStatus(response)) {
          setModuleConstantList(response?.data?.data)
        }
      })
  }
   const getModuleDescriptionApi = (params, query) => {
       globalGetService(`console/v2/asset/engine/${params}/llp/`, { for_reserve_account: query })
         .then(response => {
           if (checkApiStatus(response)) {
             const updatedResponse = response?.data?.data?.map(item => ({
               label: item,
               value: `${item?.toLowerCase()}_event`
             }));
             const activeModules = updatedResponse?.filter(option => item.id ? (((item?.shop_visit_events && item?.shop_visit_events[option.value]) || (item?.shop_visit_events?.other_events &&  item?.shop_visit_events?.other_events[option.value]))) : ((event?.other_events &&  event?.other_events[option.value]) ||  (event && event[option.value])));
             const mergedArray = activeModules?.map(item => {
               const match = moduleConstantList?.find(ref => ref.label === item.label);
               return match
                 ? { ...item, moduleValue: match.value, }
                 : item;
             });
             setVerifyAmountData({...verifyAmountData,moduleList : mergedArray})
           }
         })
     }

       useEffect(() => {
         if (event?.asset_slug && event?.asset_type === 2) {
           getModuleDescriptionApi(event?.asset_slug, "module");
           getEngineModuleConstant()
         };
       }, [])
  return(
    <div className="content-info payout-claim-info">
      { item?.payout_status?.value === 1 && permissionCheckFn({secondaryKey:'maintenance_claims', keyIndex:'U'}) ? <span className="edit-sv"><EditClaimPayout claimData={item} getResponseBack={getResponseBack} /></span>: null }
      { [1, 2,5,].includes(item?.payout_status?.value) ?
        <table>
          <tbody>
            <tr>
              <td>{item?.payout_status?.value === 2 ? 'Claim Payout Amount is Verified': ' Claim Payout is Pending'}</td>
              <td>
                <Button
                  color="primary"
                  variant="outlined"
                  size='small'
                  onClick={() => {
                    if (item?.payout_status?.value == 1) {
                      if(item?.asset_type === "engine"){
                        setVerifyAmountData({...verifyAmountData,modal:true})
                      } else  setVerifyAmountData({modal:true,moduleList : []})
                    } 
                    else {
                      changeClaimStatus({ payout_status: item?.payout_status?.value == 5 ? 6 : 2 })
                    }
                    trackActivity('Item Clicked', { page_title: 'Claim', item_type: item?.status?.value === 5 ? 'Mark as Paid' : 'Verify Amount', status_type: item?.status?.label, assembly_type: this?.props?.assemblyType })
                  }}
                  disabled={item?.amount_paid == 0 && !permissionCheckFn({secondaryKey:'maintenance_claims', keyIndex:'APR_REJ'})  ? true: false}
                >
                  {item?.payout_status?.value === 5 ? 'Mark as Paid': 'Verify Amount'}
                </Button>
              </td>
            </tr>
          </tbody>
        </table>:null
      }
      <Grid container spacing={3} style={{margin: 0}}>
      {item?.asset_type !== "engine" || (item?.asset_type === "engine" && !item.shop_visit_events?.prsv && !item.shop_visit_events?.llp_replacement) ?
          <LabelValueCard md={4} label='Payout Amount' value={item.amount_paid || item?.claim_amount ?
            <NumericLabel params={prettyNumberParamsDB}>{item?.amount_paid ?item.amount_paid :item?.claim_amount }</NumericLabel> : '--'} /> : null
        }
         {(event?.asset_type == 2 && event?.prsv && verifyAmountData?.moduleList?.length > 0) ?
          verifyAmountData?.moduleList?.map((module, index) =>
             {return <LabelValueCard key={index} md={4} label={module?.label} value={(item?.prsv_amount_paid && item?.prsv_amount_paid[module.label]) || (item?.prsv_claim_amount &&item?.prsv_claim_amount[module.label])  ?
              <NumericLabel params={prettyNumberParamsDB}>{item?.prsv_amount_paid && item?.prsv_amount_paid[module.label] ?item?.prsv_amount_paid[module.label] :item?.prsv_claim_amount[module.label] }</NumericLabel> : '--'} />
            })
          : null}
        {item?.asset_type === "engine" &&item.shop_visit_events?.prsv &&  verifyAmountData?.moduleList?.length === 0  ?
          <LabelValueCard md={4} label='PRSV Payout Amount' value={item?.amount_paid || item?.claim_amount ?
            <NumericLabel params={prettyNumberParamsDB}>{item?.amount_paid ?item.amount_paid :item?.claim_amount}</NumericLabel> : '--'} /> : null
        }
        {item?.asset_type === "engine" &&item.shop_visit_events?.llp_replacement  ?
          <LabelValueCard md={4} label='LLP Payout Amount  ' value={item.llp_amount_paid || item.llp_claim_amount ?
            <NumericLabel params={prettyNumberParamsDB}>{item.llp_amount_paid ?item.llp_amount_paid :item.llp_claim_amount  }</NumericLabel> : '--'} /> : null
        }
        {item?.asset_type !== "engine" || (item?.asset_type === "engine" && !item.shop_visit_events?.prsv && !item.shop_visit_events?.llp_replacement) ?
          <LabelValueCard md={4} label='Fund Balance' value={item?.fund_balance ? <NumericLabel params={prettyNumberParamsDB}>{item.fund_balance}</NumericLabel> : '--'} /> : null
        }
        {item?.asset_type === "engine" && item.shop_visit_events?.prsv ?
           <LabelValueCard md={4} label='PRSV Fund Balance' value={item?.prsv_fund_balance ? <NumericLabel params={prettyNumberParamsDB}>{item?.prsv_fund_balance}</NumericLabel> :'--'} /> : null
        }
        {item?.asset_type === "engine" && item.shop_visit_events?.llp_replacement ?
          <LabelValueCard md={4} label='LLP Fund Balance' value={item?.llp_fund_balance ? <NumericLabel params={prettyNumberParamsDB}>{item?.llp_fund_balance}</NumericLabel> :'--'} /> : null
        }

        <LabelValueCard md={4} label='Payout Status' value={item.payout_status.label}/>
        <LabelValueCard md={4} label='Transaction Number' value={item.reference_number ? item.reference_number:'--'} />
        <LabelValueCard md={4} label='Transaction Details' value={item.transaction_description ? item.transaction_description:'--'} />
        <LabelValueCard md={4} label='Remarks' value={item.remarks ? item.remarks:'--'} />
        <LabelValueCard md={4} label='Payout Date' value={item?.payout_date ? moment(item.payout_date).format('MMM DD, YYYY'):'--'} />
      </Grid>
      {verifyAmountData?.modal ?   <VerifyAmountModal handleTabChange={handleTabChange} item={item} event={event} changeClaimStatus={changeClaimStatus} verifyAmountData={verifyAmountData} getResponseBack={getResponseBack} 
      toggleModalFn={()=>setVerifyAmountData({...verifyAmountData,modal:false})}
      />:null}
    
    </div>
  )
}
